// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateMembershipPageView_container__2Nrg_"};